import {Component} from '@angular/core';
import {Autowired} from '@angular-ru/autowired';
import {TypeDocumentAutocompleteFormMetierService} from './type-document-autocomplete.form.metier.service';
import {AtlantisAutocompleteComponent} from '@shared/behaviors/atlantis-extend-clv/atlantis-autocomplete/atlantis-autocomplete.component';

@Component({
  selector: 'app-type-document-autocomplete',
  template: `
    <app-atlantis-autocomplete [label]="label"
                               [options]="options$ | async"
                               [hasAction]="hasAction"
                               [actionGestionnaireDeModale]="actionGestionnaireDeModale"
                               [required]="required"
                               [control]="control"
                               [placeholder]="placeholder"
                               [actionColor]="actionColor"
                               [actionIcon]="actionIcon"
                               (onChange)="onChange?.emit($event)"
                               (onBlur)="onBlur?.emit($event)"
                               (onClick)="onClick?.emit($event)"
                               (onFocus)="onFocus?.emit($event)"
                               (onShow)="onShow?.emit($event)"
                               (onHide)="onHide?.emit($event)"
                               [recupererOptionsMetier]="recupererOptionsMetier"
                               [args]="args"
                               [name]="name"
                               [extOptions]="extOptions"
                               [searchField]="searchField"
                               [field]="field"
                               (actionDeclenche)="actionDeclenche.emit($event)"
                               (onSelect)="onSelect.emit($event)">
    </app-atlantis-autocomplete>
  `
})
export class TypeDocumentAutocompleteComponent extends AtlantisAutocompleteComponent {
  @Autowired() recupererOptionsMetier: TypeDocumentAutocompleteFormMetierService;

  constructor() {
    super();
    this.label = 'Type Document';
    this.name = 'type document';
  }
}
